import { getDefaultLang } from "@cervval.js/common/src/i18n/languages";

const _en = {
    description: "Select the days you wish to work and allocate your working hours to them"
};

export type I18nTypicalWeek = typeof _en;

const _fr: I18nTypicalWeek = {
    description: "Sélectionnez les journées souhaitées afin de leur attribuer vos horaires de travail"
};

/**
 * Return value in required language
 * @param lang Chosen lang
 * @returns 
 */
export function I18n(lang?: string): I18nTypicalWeek {
    lang = lang ?? getDefaultLang();
    switch (lang) {
        case "en":
            return _en;
        case "fr":
        default:
            return _fr;
    }
}